// Warning: /a|b|c/ + /d|e|f/ -> /a|b|cd|e|f/
// Solution: wrap unions in /(...)/ to avoid that problem if using
// the resulting pattern in a context where that may cause issues.
export const union = (...options: string[]) => options.join('|');

// Good for wrapping unions in /(...)/
export const captureGroup = (str: string) => `(${str})`;
